import { render } from "./VerifyPoints.vue?vue&type=template&id=487d0090"
import script from "./VerifyPoints.vue?vue&type=script&lang=js"
export * from "./VerifyPoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/verifition/Verify/VerifyPoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "487d0090"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('487d0090', __exports__)) {
    api.reload('487d0090', __exports__)
  }
  
  module.hot.accept("./VerifyPoints.vue?vue&type=template&id=487d0090", () => {
    api.rerender('487d0090', render)
  })

}


export default __exports__